<template>
  <div class="mn606-chart-wrap" :class="{ 'is-mobile': isMobile }">
    <div class="mn606-chart__content">
      <template v-for="row in rows">
        <div
          class="mn606-chart-card"
          :style="{ '--col': row.length, '--row': rows.length }"
          v-for="col in row"
          :key="col.sensorSeq"
        >
          <chart ref="chart" :data="col"></chart>
        </div>
      </template>
      <!-- <el-row v-for="(row, i) in rows" :gutter="20" :key="`row_${i}`">
        <el-col :span="24 / row.length" v-for="col in row" :key="col.sensorSeq">
          <chart ref="chart" :height="calcHeight(row.length)" :data="col" class="mt-15"></chart>
        </el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
import Chart from './chart.vue';

export default {
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Chart
  },
  computed: {
    rows() {
      const { datas } = this;
      let colNum = datas.length === 4 ? 2 : 4;

      if (this.$i18n.locale === 'ru') {
        colNum = 2;
      }

      if (this.isMobile) {
        const dict = {
          'zh-CN': 2,
          ar: 2,
          ru: 1,
          en: 2,
          fr: 2,
          es: 2
        };

        colNum = dict[this.$i18n.locale];
      }

      const rows = [];
      let offset = 0;
      for (let i = 0, j = Math.ceil(datas.length / colNum); i < j; i++) {
        offset = i * colNum;
        rows.push(datas.slice(offset, offset + colNum));
      }
      return rows;
    }
  },
  methods: {
    setData(list, data) {
      this.$nextTick(() => {
        let temp = [];
        Array(list[0].sensorDataList.length)
          .fill(0)
          .forEach((_, i) => {
            temp = list.map(e => ({
              beginTime: e.beginTime,
              ...(e.sensorDataList[i] || {})
            }));
            this.$refs.chart[i].setDataList(temp, data.sensorDataList[i]);
          });
      });
    }
  }
};
</script>

<style lang="scss">
.mn606-chart-wrap {
  $height: calc(100% - 168px);
  $gap: 15px;
  height: $height;
  margin-top: $gap;

  width: 100%;
  overflow: hidden;
  .mn606-chart__content {
    height: 100%;
    width: 100%;

    display: flex;
    flex-wrap: wrap;
    gap: $gap;

    overflow-y: scroll;
    overflow-x: hidden;
    @include scrollar-style-none;

    .mn606-chart-card {
      --col: 4;
      --row: 1;
      --rat: calc((var(--col) - 1) / var(--col));

      width: calc(100% / var(--col) - $gap * var(--rat));
      height: calc(max(100% / var(--row), 50%) - $gap * var(--rat));
    }
  }

  &.is-mobile {
    $height: calc(100% - 168px);
    $gap: 5px;
    height: $height;
    margin-top: $gap;

    .mn606-chart__content {
      .mn606-chart-card {
        height: calc(100% - $gap * 3);
      }
    }
  }
}
</style>
